import React, { useEffect } from "react";

import { IgListItemButton, IgSelect } from "@intelligems/ig-theme";
import { VisitorType } from "@intelligems/ig-types";
import { Grid, MenuItem } from "@mui/material";

interface VisitorProps {
  onClick: (arg1: any, arg2?: any) => void;
  visitorType?: VisitorType | null;
}

export const visitorTypeList: {
  label: string;
  key: VisitorType | undefined;
}[] = [
  {
    label: "All Visitors",
    key: "any",
  },
  {
    label: "New",
    key: "new",
  },
  {
    label: "Returning",
    key: "returning",
  },
];

export const Visitor = ({ visitorType, onClick }: VisitorProps) => {
  const selectedCard = (selectedVisitorType: string | undefined): boolean => {
    return visitorType === selectedVisitorType;
  };

  return (
    <Grid container spacing={2} direction={"row"}>
      {visitorTypeList.map((visitorType) => (
        <Grid item xs={4} key={visitorType.key}>
          <IgListItemButton
            igVariant={"primary"}
            label={visitorType.label}
            onClick={() => {
              onClick(visitorType.key, "visitorType");
            }}
            selected={selectedCard(visitorType.key)}
          />
        </Grid>
      ))}
    </Grid>
  );
};

interface VisitorSelectProps {
  onChange: (value: any, changeKey: "key" | "filter" | "value") => void;
  visitorType: VisitorType;
}

// make a visitor select dropdown just like DeviceSelect
export const VisitorSelect = ({
  onChange,
  visitorType,
}: VisitorSelectProps) => {
  // handle when type switched and value not compatible
  useEffect(() => {
    if (!visitorTypeList.find((visitor) => visitor.key === visitorType))
      onChange(visitorTypeList[1].key, "value");
  }, []);

  return (
    <Grid item>
      <IgSelect
        variant={"outlined"}
        key={`visitor-type`}
        value={visitorType || visitorTypeList[1].key}
        onChange={(e) => {
          onChange(e.target.value, "value");
        }}
      >
        {visitorTypeList
          .filter((visitorType) => !!visitorType.key)
          .map((visitorType) => (
            <MenuItem key={visitorType.key} value={visitorType.key}>
              {visitorType.label}
            </MenuItem>
          ))}
      </IgSelect>
    </Grid>
  );
};
